module.exports = {"230303001":"桦木林街道","230303002":"大恒山街道","230303003":"小恒山街道","230303004":"二道河子街道","230303005":"张新街道","230303006":"奋斗街道","230303007":"柳毛街道","230303200":"红旗乡","230303201":"柳毛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230303.json
// module id = 707
// module chunks = 0